export const navLinks = [
  {
    name: 'Who We Are',
    href: '/who-we-are',
  },
  {
    name: 'Solutions',
    href: '/solutions',
  },
  {
    name: 'Industries',
    href: '/industries',
  },
  {
    name: 'Pricing',
    href: '/pricing',
  },
  {
    name: 'Resources',
    href: '/resources',
  },
  {
    name: 'Contact',
    href: '/contact',
  },
]

export const footerColumns = [
  {
    title: 'Company',
    links: [
      {
        name: 'Home',
        href: '/',
      },
      {
        name: 'Who We Are',
        href: '/who-we-are',
      },
      {
        name: 'Contact',
        href: '/contact',
      },
    ],
  },
  {
    title: 'Platform',
    links: [
      {
        name: 'Solutions',
        href: '/solutions',
      },
      {
        name: 'Industries',
        href: '/industries',
      },
      {
        name: 'Pricing',
        href: '/pricing',
      },
    ],
  },
  {
    title: 'Insights',
    links: [
      {
        name: 'Resources',
        href: '/resources',
      },
      {
        name: 'Privacy Policy',
        href: '/resources',
      },
      {
        name: 'Terms & Conditions',
        href: '/resources',
      },
    ],
  },
]

export const LOGO_URL =
  'https://cdn.magicpatterns.com/uploads/oTehAPnzusxNxLDwzERY7G/ChatGPT_Image_Jul_13,_2026,_03_08_42_PM.png'
